import { Component, inject } from '@angular/core';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import { MatButton } from '@angular/material/button';
import { Router } from '@angular/router';
import { HeaderComponent } from '../../shared/components/header/header.component';

/**
 * 活動已結束
 */
@Component({
  selector: 'app-not-available',
  standalone: true,
  imports: [TranslatePipe, MatButton, HeaderComponent],
  templateUrl: './not-available.component.html',
  styleUrl: './not-available.component.scss',
})
export class NotAvailableComponent {
  router: Router = inject(Router);
  translateService: TranslateService = inject(TranslateService);

  constructor() {
    this.translateService.onLangChange.subscribe(() => {
      //等i18語系載入完成後再執行以下內容
      console.log('活動已結束');
      console.log('環境配置:', (window as any)?.env?.environment);
    });
  }

  // 返回首頁
  backToHome() {
    this.router.navigate(['/healthcheck']).then();
  }
}
